import React, { useContext, useEffect } from 'react'
import { LocationContext } from '../../../context/LocationContext'
import { Form } from 'react-bootstrap';

const DistrictFilter = ({ value, onChange, placeholder = 'All District', className, style, setCurrentPage }) => {
    const { districtList, fetchDistricts, selectedDistrictId, setSelectedDistrictId } = useContext(LocationContext);

    const handleChange = (e) => {
        const val = e.target.value;
        const selectedDistrict = districtList.find(d => String(d.id) === String(val));
        const districtName = selectedDistrict ? selectedDistrict.label : "";

        if (onChange) {
            onChange(val, districtName);
        } else {
            setSelectedDistrictId(val);
            if (setCurrentPage) setCurrentPage(1);
        }
    };

    useEffect(() => {
        fetchDistricts();
    }, []);

    const currentValue = value !== undefined && value !== null ? value : selectedDistrictId;

    return (
        <>
            <div>
                <Form.Select
                    value={currentValue}
                    onChange={handleChange}
                    className={className || 'me-2'}
                    style={style || { width: '100%', padding: '11px 40px 11px 11px' }}
                >
                    <option value="">{placeholder}</option>
                    {districtList.map((item) => {
                        return (
                            <option key={item.id} value={item.id}>{item?.label}</option>
                        )
                    })}
                </Form.Select>
            </div>
        </>
    )
}

export default DistrictFilter
